<div class="feedback">
  <h1 class="main-title">Feedback</h1>
  <p class="main-body">Help us improve {{ productName }}!</p>
  <div class="container">
    <a class="feed item-flex-container" [href]="feedbackUrl" target="_blank">
      <div class="circle">
        <svg-icon src="/assets/icons/feedback.svg"></svg-icon>
      </div>
      <span class="bottom-text">Feedback & Ideas</span>
    </a>
    <a
      [ngClass]="{ 'hide-vote': !showVote }"
      class="vote item-flex-container"
      href="https://portal.productboard.com/bufkuovdmcc4aeqrdqsndgdo"
      target="_blank">
      <div class="circle">
        <svg-icon src="/assets/icons/icons-nav-thumbs-up.svg"></svg-icon>
      </div>
      <span class="bottom-text">Vote on what's next</span>
    </a>
    <a class="bugs item-flex-container" [href]="bugUrl" target="_blank">
      <div class="circle">
        <svg-icon src="/assets/icons/bug.svg"></svg-icon>
      </div>
      <span class="bottom-text">Report a bug</span>
    </a>
  </div>
</div>
